import { usePrivacy } from "#contexts/PrivacyContext"
import { useI18n } from "#hooks/use-i18n"
import { Eye, EyeOff } from "lucide-react"
import { useEffect, useState } from "react"
import { Button } from "./ui/button"

export function PrivacyToggle() {
  const { t } = useI18n()
  const { isBlurred, toggleBlur } = usePrivacy()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const button = (
    <Button
      variant="outline"
      size="icon"
      onClick={mounted ? toggleBlur : undefined}
      disabled={!mounted}
      className="w-9 h-9 shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
      title={
        mounted
          ? isBlurred
            ? t("components.privacy.showNumbers")
            : t("components.privacy.hideNumbers")
          : undefined
      }
    >
      {mounted ? (
        isBlurred ? (
          <EyeOff className="w-5 h-5" />
        ) : (
          <Eye className="w-5 h-5" />
        )
      ) : (
        <div className="w-5 h-5" />
      )}
    </Button>
  )

  return button
}
